export default __webpack_public_path__ + "static/body-v2-09-rise-d408c980f3725c048a01caba2e6b1d79.png";